
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "crop-image-preview"
})
export default class CropImagePreviewComponent extends Vue {
  @Prop({ default: "" }) imageSrc!: string;
  @Prop({ default: 182 }) elHeight!: number;

  get containerStyle(): Record<string, string> {
    return {
      height: this.elHeight + "px"
    };
  }
}
